import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { logPageView } from '@/stores/activity'
// import HomeView from '../views/HomeView.vue'
// import CostView from '../views/CostView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/period' },

    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { public: true },
    },

    {
      path: '/system/users',
      name: 'systemUsers',
      component: () => import('../views/SystemUsersView.vue'),
    },
    {
      path: '/my-account/:section',
      name: 'myAccount',
      component: () => import('../views/MyAccountView.vue'),
    },
    {
      path: '/cost',
      name: 'cost',

      component: () => import('../views/CostView.vue')
    },

    {
      path: '/employee',
      name: 'employee',

      component: () => import('../views/EmployeeView.vue')
    },

    {
      path: '/account',
      name: 'account',
      component: () => import('../views/AccountView.vue')
    },

    {
      path: '/payslip',
      name: 'payslip',
      component: () => import('../views/PayslipView.vue')
    },

    {
      path: '/schedule',
      name: 'schedule',
      component: () => import('../views/ScheduleView.vue')
    },

    {
      path: '/transact/:type',
      name: 'transact',
      component: () => import('../views/TransactView.vue')
    },

    {
      path: '/dailytime/:type',
      name: 'dailytime',
      component: () => import('../views/TimeView.vue')
    },
    
    {
      path: '/table/:type',
      name: 'table',
      component: () => import('../views/TableView.vue')
    },
    
    
    {
      path: '/upload',
      name: 'upload',
      component: () => import('../views/UploadView.vue')
    },

    {
      path: '/period',
      name: 'period',
      component: () => import('../views/PeriodView.vue')
    },

    {
      path: '/leave/:type',
      name: 'leave',
      component: () => import('../views/LeaveView.vue')
    },
    
    {
      path: '/leave-credits',
      name: 'leaveCredits',
      component: () => import('../views/LeaveCreditsView.vue')
    },

    {
      path: '/leave-conversion',
      name: 'leaveConversion',
      component: () => import('../views/LeaveConversionView.vue')
    },

    {
      path: '/company/:type',
      name: 'company',
      component: () => import('../views/CompanyView.vue')
    },
    
    {
      path: '/department',
      name: 'department',
      component: () => import('../views/DepartmentView.vue')
    },
    
    {
      path: '/loan',
      name: 'loan',
      component: () => import('../views/LoanView.vue')
    },
    
    {
      path: '/setup/settings',
      name: 'settings',
      meta: { requiresAdmin: true },
      component: () => import('../views/SettingsView.vue')
    },

    {
      path: '/setup/devices',
      name: 'devices',
      meta: { requiresAdmin: true },
      component: () => import('../views/DevicesView.vue')
    },

    {
      path: '/system/activity',
      name: 'activity',
      meta: { requiresManagement: true },
      component: () => import('../views/ActivityLogView.vue')
    },

    {
      path: '/device-blocked',
      name: 'deviceBlocked',
      meta: { public: true },
      component: () => import('../views/DeviceBlockedView.vue')
    },

    {
      path: '/preview/:report/:uuid',
      name: 'preview',
      component: () => import('../views/ReportView.vue')
    },
  ]
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true
  const authStore = useAuthStore()
  if (!authStore.isAuthenticated) {
    const ok = await authStore.checkAuth()
    if (!ok) return { name: 'login' }
  }
  if (to.meta.requiresManagement && !authStore.isManagement) {
    await authStore.checkAuth()
    if (!authStore.isManagement) return { path: '/period' }
  }
  if (to.meta.requiresAdmin && !authStore.isAdmin) {
    // roles are refreshed by checkAuth; ask once before turning an admin away
    await authStore.checkAuth()
    if (!authStore.isAdmin) return { path: '/period' }
  }
  return true
})

// Every screen visited by a signed-in user is a line in the activity log
let lastLogged = ''
router.afterEach((to) => {
  if (to.meta.public || to.path === lastLogged) return
  lastLogged = to.path
  logPageView(String(to.name ?? to.path), to.fullPath)
})

export default router
